<template>
  <div class="wrapper">
    <h1>{{content.data.title}}</h1>
    <p>{{content.data.description}}</p>
    <div class="">
      <div class=""
        v-for="(item, index) in content.data.list"
        v-bind:key="index"
        :class="{active : activeIndex == index}"
        @click="activate(index)"
      >
        <p>{{item}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextHighlight',
  components: {
  },
  data () {
    return {
      activeIndex: {
        type: Number
      }
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    }
  },
  computed: {
    content () {
      return this.$store.getters.getData(this.dataId)
    }
  },
  methods: {
    activate (index) {
      if (this.activeIndex === index) {
        this.activeIndex = -1
      } else {
        this.activeIndex = index
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/text-highlight/TextHighlight.vue